<script setup lang="ts">
import { GoogleMap } from 'vue3-google-map'
import { computed, ref } from 'vue'
import { appMapStyles } from '@/components/BrandedV2/AppMap/utils'
import type { AppMapComponentModule } from '@/components/BrandedV2/AppMap/types'

defineEmits(['click', 'dragend'])

const googleMapRef = ref()
const props = withDefaults(defineProps<AppMapComponentModule.Props>(), {
  containerStyles: 'width: 100%; height: 100%',
  disableDefaultUi: true,
  gestureHandling: 'greedy',
  mapStyles: null,
  zoom: 10,
  zoomControl: false
})

const googleMapStyles = computed<Record<string, any>[]>(() => {
  return props.mapStyles || appMapStyles
})

const mapCoordinatesToLatLng = computed(() => {
  const { latitude: lat, longitude: lng } = props.mapCoordinatesCenter
  return { lat, lng }
})

defineExpose({
  googleMapRef
})
</script>
<script lang="ts">
export default {
  name: 'AppMap'
}
</script>

<template>
  <GoogleMap
    ref="googleMapRef"
    :api-key="apiKey"
    :style="containerStyles"
    :styles="googleMapStyles"
    :disable-default-ui="disableDefaultUi"
    :center="mapCoordinatesToLatLng"
    :zoom-control="zoomControl"
    :zoom="zoom"
    :gesture-handling="gestureHandling"
    @click="$emit('click')"
    @dragend="$emit('dragend')">
    <slot name="customMarker" />
  </GoogleMap>
</template>
